// extracted by mini-css-extract-plugin
export default {"advtWrapper":"Advt_advtWrapper__hQTBZ","qrsWrapper":"Advt_qrsWrapper__AKe4A","qrCode":"Advt_qrCode__AW7EV","borderQr":"Advt_borderQr__tIG-s","phoneNumber":"Advt_phoneNumber__nGccl"};